module.exports = __webpack_public_path__ + "img/Blendify_logo_full.c4eeb37f.png";